<div class="snackbar-bottom">
    <app-snackbar-host name="bottom"></app-snackbar-host>
</div>
